export const changeLanguage = (type) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_SELECTED_LANGUAGE',
      payload: type
    });
  }
}

export const changePrevLanguage = (type) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_PREV_LANGUAGE',
      payload: type
    });
  }
}
